const namespaces = {
  a: 'http://schemas.openxmlformats.org/drawingml/2006/main',
  b: 'http://schemas.openxmlformats.org/officeDocument/2006/bibliography',
  cdr: 'http://schemas.openxmlformats.org/drawingml/2006/chartDrawing',
  dc: 'http://purl.org/dc/elements/1.1/',
  dcmitype: 'http://purl.org/dc/dcmitype/',
  dcterms: 'http://purl.org/dc/terms/',
  o: 'urn:schemas-microsoft-com:office:office',
  pic: 'http://schemas.openxmlformats.org/drawingml/2006/picture',
  r: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
  v: 'urn:schemas-microsoft-com:vml',
  ve: 'http://schemas.openxmlformats.org/markup-compatibility/2006',
  vt: 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
  w: 'http://schemas.openxmlformats.org/wordprocessingml/2006/main',
  w10: 'urn:schemas-microsoft-com:office:word',
  wp: 'http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing',
  wne: 'http://schemas.microsoft.com/office/word/2006/wordml',
  xsd: 'http://www.w3.org/2001/XMLSchema',
  xsi: 'http://www.w3.org/2001/XMLSchema-instance',
  numbering: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering',
  hyperlinks: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink',
  images: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image',
  styles: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles',
  headers: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/header',
  footers: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer',
  themes: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme',
  coreProperties: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
  officeDocumentRelation:
    'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument',
  corePropertiesRelation:
    'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties',
  settingsRelation: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings',
  webSettingsRelation:
    'http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings',
  sl: 'http://schemas.openxmlformats.org/schemaLibrary/2006/main',
  contentTypes: 'http://schemas.openxmlformats.org/package/2006/content-types',
  relationship: 'http://schemas.openxmlformats.org/package/2006/relationships',
};

export default namespaces;
